import { createFileRoute } from '@tanstack/react-router';
import { OAuthCallback } from '~/components/OAuthCallback';

export const Route = createFileRoute('/sso/callback/$provider' as any)({
  component: function Body() {
    return (
      <OAuthCallback
        providers={[
          'google',
          'apple',
          'microsoft',
          'github',
          'facebook',
        ]}
      />
    );
  },
});
